import React from 'react';
import { PencilIcon, CreditCardIcon } from "@heroicons/react/outline";
import _ from 'lodash';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ButtonShareWithRecipient from "../../components/ButtonShareWithRecipient";
import { copyToClipboard, addEventNameToEndpoint } from "../../utils/common";
import truncateString from "../../utils/truncateString";
import {
  Button,
  ButtonGroup
} from "react-bootstrap";
import { iconCollectionNormalGreen, iconCollectionSelectedGreen } from "../../assets/icons";
import ActionConfirmForm from '../../components/common/ActionConfirmForm';
import { USER_SETTINGS } from "../../constants/UserSettings";
import { ShareType } from "../../constants/Types";
import { PROMPT_ACTION_FORM } from "../../constants/Messages";

const ReactSwal = withReactContent(Swal);

const CollectionItem = props => {
  const [isShareOptions, setIsShareOptions] = React.useState(true);
  const shareLinkRef = React.createRef();

  React.useEffect(() => {
    if (props.selected) {
      setIsShareOptions(true);
    }
  }, [props.selected]);

  const onShareSite = (e) => {
    e.preventDefault();
    e.stopPropagation();
    copyToClipboard(props.site.urlPath, 'Copied share URL of site to clipboard.');
  }

  const changeNotificationPermission = () => {
    if (_.get(props.settings, `userInfo.${USER_SETTINGS.APP_OPTIONS.PUSH_ENABLED}`, true)) {
      if (!('Notification' in window)) {
        console.log("This browser does not support notifications.");
      } else {
        if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {

          ReactSwal.fire({
            allowOutsideClick: true,
            allowEscapeKey: true,
            allowEnterKey: false,
            showCancelButton: false,
            showConfirmButton: false,
            html: (
              <ActionConfirmForm
                onConfirm={ReactSwal.clickConfirm}
                onClose={ReactSwal.clickCancel}
                title={PROMPT_ACTION_FORM.NOTIFICATIONS.TITLE}
                question={PROMPT_ACTION_FORM.NOTIFICATIONS.BODY}
              />
            )
          })
          .then(async result => {
            if (result.value) {
              try {
                await Notification.requestPermission();
              } catch (error) {
                console.log('error happend during request permission for browser notification');
                console.log(error);
              }
            }
          });
        }
      }
    }
  }

  const onClickCopyShortUrl = e => {
    e.stopPropagation();
    e.preventDefault();

    addEventNameToEndpoint(props.Analytics, 'user-shorturl-copy');
    copyToClipboard(_.get(props, 'site.urlPath', ''), 'Copied share URL of site to clipboard.');
  }

  const onFinishShareUrlHandler = () => {
    setIsShareOptions(false);
  }

  return (
    <div className="collection-item" onClick={props.onClick}>
      <div className="collection-item-bar">
        <div className="flex items-center">
          <img className="collection-icons mr-2" src={props.selected ? iconCollectionSelectedGreen : iconCollectionNormalGreen} alt="collection" />
          <span className="collection-name">{truncateString(props.collection.title, 20)}</span>
        </div>
        <div className="ml-2 collection-actions">
          {props.site && <CreditCardIcon className="icons credit" onClick={onShareSite} />}
          <PencilIcon className="icons" onClick={props.onEdit} />
        </div>
      </div>
      {props.selected && props.site && isShareOptions &&
      <div ref={shareLinkRef} className="mt-2 mb-1 share-actions" onClick={e => e.stopPropagation()}>
        <ButtonGroup aria-label="Sharing Actions">
          <Button variant="outline-light" className="mr-2" size="sm" 
            id="btnCollectionItemShare"
            data-cc-analytics-on='click'
            data-cc-analytics-name='user-shorturl-copy'
            data-cc-analytics-attrs={`siteId:${_.get(props, 'site.id', "")},shortUrl:${_.get(props, 'site.urlPath', "").replace('https://', '')}`}
            onClick={onClickCopyShortUrl}>
            LINK
          </Button>
          <ButtonShareWithRecipient
            variant="outline-light"
            itemId={_.get(props, 'site.id', "")}
            itemType={ShareType.Site}
            itemShortUrl={_.get(props, 'site.urlPath', "")}
            changeNotificationPermission={changeNotificationPermission}
            onChangeEvent={onFinishShareUrlHandler}
          />
        </ButtonGroup>
      </div>}
    </div>
  );
}

export default CollectionItem;
